import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { Case } from '../../types';

interface CaseHeaderProps {
  case_: Case;
}

export const CaseHeader: React.FC<CaseHeaderProps> = ({ case_ }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>{case_.title}</Typography>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Chip label={`Case #${case_.caseNumber}`} variant="outlined" />
        <Chip label={case_.practiceArea} variant="outlined" />
        <Chip
          label={case_.status}
          color={case_.status === 'active' ? 'success' : 'default'}
        />
      </Box>
    </Box>
  );
};